import React from "react";
import useInView from "../../../hooks/useInView";
import "./TarjetaDeServicioConsultoria.css";

interface ServiceItem {
  title: string;
  desc: string;
}

interface TarjetaDeServicioConsultoriaProps {
  service: ServiceItem;
  delay?: number;
  animationClass?: string;
}

export default function TarjetaDeServicio({ service, delay = 0, animationClass = "" }: TarjetaDeServicioConsultoriaProps) {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <div
      ref={ref}
      className={`serviceconsultoria-card${inView ? " visible" : ""} ${animationClass}`}
      style={{ transitionDelay: `${delay}s` } as React.CSSProperties}
    >
      <h3 className="serviceconsultoria-card-title">{service.title}</h3>
      <p className="serviceconsultoria-card-text">{service.desc}</p>
    </div>
  );
}